type CorrectionMap = Record<string,string>;

const KEY = 'ocr-learning-database';

export function loadCorrections(): CorrectionMap {
  try {
    return JSON.parse(
      localStorage.getItem(KEY) || '{}'
    );
  } catch {
    return {};
  }
}

export function saveCorrection(
  wrong: string,
  correct: string
) {
  if (
    !wrong ||
    !correct ||
    wrong === correct
  ) return;

  const db = loadCorrections();

  db[wrong] = correct;

  localStorage.setItem(
    KEY,
    JSON.stringify(db)
  );
}

export function applyLearnedCorrections(
  text: string
) {
  const db = loadCorrections();

  let result = text;

  Object.entries(db).forEach(
    ([wrong, correct]) => {
result = result.replace(
  new RegExp(wrong, 'g'),
  correct
);
    }
  );

  return result;
}
